import React from 'react';

interface SidebarProps {
  theme: 'cnw' | 'krissco';
  sections: Array<{ id: string; num: string; title: string }>;
}

const HandbookSidebar: React.FC<SidebarProps> = ({ theme, sections }) => {
  return (
    <nav className="handbook-sidebar">
      <div className="nav-section-label">Contents</div>
      {sections.map((section) => (
        <a key={section.id} href={`#${section.id}`} className="nav-item">
          <span className="num">{section.num}</span>
          {section.title}
        </a>
      ))}
    </nav>
  );
};

export default HandbookSidebar;
